import {ASK_CALCULATE} from '../actions/index';

export default function (state = null, action) {
  switch (action.type) {
    case ASK_CALCULATE:
      return action.payload.data;
    default:
      break;
  }
  return state;
}
